<template lang="pug">
  v-container(style="max-width:1024px; position: relative;")
    v-icon(v-if="isMobile" style="z-index: 10; position: absolute; left: 0; top: 0;" size="65" color="#30b5bb" @click="$router.go(-1)") mdi-chevron-left
    h2(v-if="isMobile").create-shop__title.create-shop__underline {{ model.id ? 'Actualizar' : 'Crear' }} Tienda
    // Tutorial
    tutorial(:component="'shop'" :showLetters="false" style="position: absolute; right: -2%; top: 1.5%;").mr-md-6
    v-dialog(persistent :value='onBoardingDialog' max-width='600px' transition="dialog-bottom-transition")
      div(style ='position:relative; height: 100%;')
        on-boarding(@close="onBoardingDialog=false")
    v-dialog( persistent  :value='createCategoryDialog'  max-width='500px'   transition="dialog-bottom-transition")
      div(style ='position:relative; height: 100%;')
        create-category( @close="createCategoryDialog=false")
    v-container
      formStepper(:model ='model', :verification="verification" :field='field' :onSave='createItem' :categorySelected='categorySelected' :context='currentContext' @cancel="cancel" @openCategoryModal="createCategoryDialog = true")
    v-snackbar(v-model='snackbar.snackbar' :color='snackbar.color' :center="true" :timeout='snackbar.timeout' :top="true")
      | {{ snackbar.text }}
      v-btn(dark='' text='' @click='snackbar.snackbar = false')
        | {{$t('payment.general.close')}}
</template>
<script>
  import Stepper from '@/components/custom/steppers/ShopStepper'
  import CreateCategory from '@/views/custom/CreateCategory'
  import onBoarding from '@/components/custom/tutorials/onBoarding'
  let vm = null
  export default {
    components: {
      formStepper: Stepper,
      CreateCategory: CreateCategory,
      onBoarding: onBoarding,
      Tutorial: () => import('@/components/custom/Tutorial'),
    },
    data: () => ({
      categorySelected: '',
      onBoardingDialog: false,
      verification: {
        salePointRestriction: null,
        salePointDays: null,
        totalShops: 0,
        initDateSubs: null,
        status: null,
        addNew: true,
      },
      model: {
        virtual: false,
        status: {
          val: 'active',
        },
        initDate: null,
        uid: null,
        name: null,
        type: 'product',
        price: {
          buy: null,
          sale: null,
        },
        pictures: {
          imageInput1: '',
        },
      },
      snackbar: {
        color: '',
        snackbar: false,
        text: '',
        timeout: 6000,
      },
      createCategoryDialog: false,
      field: {
        types: [{ name: 'Punto de venta', value: 'pos' }, { name: 'Bodega', value: 'warehouse' }],
      },
      currentContext: 'posts',

    }),
    computed: {
      isMobile () {
        return window.innerWidth < 1024
      },
      shops () {
        return this.$store.state.shops.shops_list
      },
      icon () {
        const category = this.model.category
        let categoryIcon = null
        switch (category) {
          case 'nation':
            categoryIcon = 'mdi-alpha-n-box'
            break
          case 'economy':
            categoryIcon = 'mdi-alpha-e-box'
            break
          case 'life':
            categoryIcon = 'mdi-alpha-v-box'
            break
          case 'international':
            categoryIcon = 'mdi-alpha-i-box'
            break
          case 'trending':
            categoryIcon = 'mdi-alpha-v'
            break
          case 'sports':
            categoryIcon = 'mdi-alpha-d-box'
            break
          case 'entertainment':
            categoryIcon = 'mdi-alpha-e'
            break
          case 'technology':
            categoryIcon = 'mdi-alpha-c-box'
            break
        }
        return categoryIcon
      },
    },
    created () {
      vm = this
      // const database = firebase.database();
      // const storage = firebase.storage();
      // this.$store.dispatch('users/getRestrictions').then(res => {
      //   // console.log(res)
      //   this.verification.salePointRestriction = res.restrictions.salePoints
      //   this.verification.salePointDays = res.restrictions.freeVirtualShopDays
      //   this.verification.status = res.status.val
      // }, rej => {
      //   this.setDataNotification(true, 'error', this.$t('shop.createModule.errorGetRestriction'))
      // })

      const date = new Date()

      const options = {
        year: 'numeric',
        month: '2-digit',
        day: 'numeric',
      }
      this.model.initDate = date.toLocaleDateString('en', options)
      if (vm.$route.params.category) {
        vm.categorySelected = vm.$route.params.category
      }
    },
    mounted () {
      const vm = this
      if (vm.shops.length === 0) {
        vm.onBoardingDialog = true
      }
    },
    methods: {
      setDataNotification (ban, color, text) {
        this.snackbar.snackbar = ban
        this.snackbar.color = color
        this.snackbar.text = text
      },
      createItem: function () {
        // A post entry.
        const vm = this
        const itemData = vm.model
        // console.log(itemData)
        // this.$store.commit('setLoading', true);
        vm.$store.commit('shops/SET_LOADING', true)
        setTimeout(function () {
          // console.log(itemData, 'soy la data de la tienda')
          // console.log(itemData.id, 'ID de la nueva tienda')
          this.$store.dispatch('shops/createItem', itemData).then((res) => {
            vm.onSuccess(res)
            vm.$store.commit('shops/SET_LOADING', false)
            itemData.categories.forEach(element => {
              // console.log(element)
              if (element.preset) {
                vm.$store.dispatch('categories/updateItem', element)
              }
            })
          })
        }.bind(this), 1000)
      },
      refresh () {
        this.model = {
          uid: null,
          name: null,
        }
      },
      onSuccess (shopID) {
        const vm = this
        vm.$swal({
          icon: 'success',
          title: 'Tienda Registrada con Éxito',
          confirmButtonText: 'Ir a la Tienda',
        }).then((result) => {
          if (result) {
            vm.$router.replace(`shops/${shopID}`)
          }
        })
        this.model = {}
        this.refresh()
        this.$emit('close')
      },
      cancel () {
        this.refresh()
        this.$emit('close')
      },
      setImage (image) {
        vm.model.imagen = image
        // // console.log(vm.model.imagen);
      },
    },
  }
</script>
<!-- Add "scoped" attribute to limit CSS to this component only -->
<style lang="scss">
    .ql-video {
        max-width: 100%;

    }
    img{
        max-width: 100%;
        height:auto;
    }

    .create-shop {
      &__title {
        text-align: center;
        color:#a3a4a5;
        margin-bottom: 1.5rem;
      }

      &__underline {
        position: relative;

        &:after {
          content:' ';
          position: absolute;
          top:120%;
          left:50%;
          width: 8rem;
          border:2px solid #30b5bb;
          border-radius:4px;
          transform:translateX(-50%);
        }
      }
    }
</style>
